// src/i18n/en/hmiSimulator.js
const hmiSimulator = {
    name: 'HMI Simulator',
    messages: {
        device_provisioned_successfully: 'Device provisioned successfully',
    },
    panel: {
        title: 'HMI Simulator',
        subtitle: 'Testing & development tool',
        device: 'Device',
        tablet: 'Tablet 7"',
        kiosk: 'Kiosk 10"',
        tablet_spec: '1024×600 · Landscape',
        kiosk_spec: '800×1280 · Portrait',
        status: 'Status',
        provisioned: 'Provisioned',
        not_provisioned: 'Not provisioned',
        connection: 'Connection',
        online: 'Online',
        offline: 'Offline',
        device_id: 'Device ID',
        screen: 'Screen',
        screen_provision: 'Provision',
        screen_main: 'Main',
        screen_locker: 'Locker',
        screen_staff: 'Staff',
        screen_settings: 'Settings',
        hotel: 'Hotel',
        name: 'Name',
        brand_color: 'Brand Color',
        languages: 'Languages',
        operation_mode: 'Operation Mode',
        mode_pms_integrated: 'PMS INTEGRATED',
        mode_email_based: 'EMAIL BASED',
        mode_tag_only: 'TAG ONLY',
        guest_access_methods: 'Guest Access Methods',
        email_code: 'Email Code',
        qr_code: 'QR Code',
        rfid_card: 'RFID Card',
        manual_reservation: 'Manual Reservation',
        pms_validation: 'PMS Validation',
        code_expiration: 'Code Expiration',
        code_length: 'Code Length',
        digits: 'digits',
        controllers: 'Controllers',
        locker_controllers: 'Locker Controllers',
        reset_device: 'Reset Device',
        reset_device_hint: 'Removes configuration and requires re-provisioning',
        getting_started: 'Getting Started',
        getting_started_text: 'Enter a provisioning code on the device screen to connect it to a hotel. The code is generated from the HMI management panel.',
        footer: 'Locker Manager · HMI Simulator v1.0',
    },
    api_monitor: {
        title: 'API Monitor',
        all: 'All',
        errors: 'Errors',
        clear: 'Clear',
        no_requests: 'No API requests yet',
    },
};

export default hmiSimulator;
